import { render, staticRenderFns } from "./ggAndIcbu.vue?vue&type=template&id=e587ee74&scoped=true"
import script from "./ggAndIcbu.vue?vue&type=script&lang=js"
export * from "./ggAndIcbu.vue?vue&type=script&lang=js"
import style0 from "./ggAndIcbu.vue?vue&type=style&index=0&id=e587ee74&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e587ee74",
  null
  
)

export default component.exports